import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { AuthService } from '../../auth.service';

@Component({
  selector: 'app-auth-error',
  standalone: true,
  imports: [CardModule, ButtonModule, TranslateModule],
  templateUrl: './auth-error.component.html',
  styleUrls: ['./auth-error.component.scss'],
})
export class AuthErrorComponent implements OnInit {
  title!: string;
  message!: string;
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly authService = inject(AuthService);

  ngOnInit(): void {
    this.title = this.activatedRoute.snapshot.data['title'];
    this.message = this.activatedRoute.snapshot.data['message'];
  }

  onHome(): void {
    this.authService.logout();
  }
}
